
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CultureMstApi } from '../../api/master/culture-mst.api';
import { CultureMst, CultureMstData } from '../../interface/master/culture-mst';

@Injectable()
export class CultureMstService extends CultureMstData {

  constructor(private api: CultureMstApi) {
    super();
  }
  list(url: string): Observable<CultureMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<CultureMst>{
      return this.api.getById(url);
  }
  create(url: string, data:CultureMst): Observable<CultureMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:CultureMst): Observable<CultureMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
